import './ListItemHeader.scss'

import { buildQueryString, KeyVal, QUERY_KEYS } from 'lib/util/routing'
import { preserveScrollAndNavigate } from 'lib/util/scrollBehavior'
import React, { MouseEvent, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'

import RecordedWebinarType from '../RecordedWebinarType'
import Series from '../Series'
import SkillLevel, { getDisplayNames } from '../SkillLevel'
import UpcomingWebinarType from '../UpcomingWebinarType'
import { SECTION_HEADER_CLASS } from './SectionHeader'

export interface ListItemHeaderProps extends RouteComponentProps {
  clearQueryKeys?: string[]
  renderSeriesLink?: boolean
  searchResults?: RecordedWebinarType[] | UpcomingWebinarType[]
  series: Series
  skillLevel: SkillLevel
}

export default withRouter(function ListItemHeader(props: ListItemHeaderProps) {
  const { clearQueryKeys = [], history, location, renderSeriesLink, series, skillLevel } = props
  const [t] = useTranslation()
  const skillLevelDisplayNames = getDisplayNames(t)
  const el = useRef(null)

  const pathname = location.pathname
  const search = buildQueryString(location, [
    [QUERY_KEYS.series, series.title],
    ...clearQueryKeys.map(key => [key] as KeyVal),
    [QUERY_KEYS.search]
  ])

  function onClick(e: MouseEvent) {
    if (e.ctrlKey || e.metaKey || e.shiftKey) {
      // don't interfere with "special" clicks
      return
    }
    e.preventDefault()
    preserveScrollAndNavigate(history, { pathname, search, scrollToSelector: `.${SECTION_HEADER_CLASS}` }, el)
  }

  return (
    <span className="list-item-header" ref={el}>
      {renderSeriesLink && (
        <Link className="list-item-header__series" onClick={onClick} to={{ pathname, search }}>
          {series.title}
        </Link>
      )}
      {renderSeriesLink && skillLevel && <span>&nbsp;|&nbsp;</span>}
      {skillLevel && <span>{skillLevelDisplayNames[skillLevel]}</span>}
    </span>
  )
})
